import { Check } from "@phosphor-icons/react";
import { WHY_CHOOSE } from "@/data/content";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-[#FAFAFA] border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <img
            src="https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg"
            alt="Professional business meeting"
            className="w-full h-[440px] object-cover grayscale-[10%]"
            loading="lazy"
          />
          <div className="absolute -bottom-6 -right-6 hidden sm:block bg-slate-900 text-white p-7 max-w-[220px]">
            <p className="font-serif-display text-2xl font-bold">Ethics first</p>
            <p className="mt-2 text-sm text-slate-300">Recovery that protects your brand and the customer&apos;s dignity.</p>
          </div>
        </div>

        <div>
          <span className="overline text-[#B91C1C]">About Crestline</span>
          <h2 className="mt-4 font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            End-to-end collection & recovery support
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed">
            Crestline Risk Management specialises in debt collection, customer follow-up, field verification and
            recovery management for banks, NBFCs, fintech companies, telecom providers and financial institutions.
            With a dedicated team of trained executives and field agents, we deliver ethical, compliant and
            result-oriented collection solutions across soft and hard collections.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {WHY_CHOOSE.map((p) => (
              <div key={p} data-testid={`about-point-${p.slice(0, 12)}`} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 items-center justify-center bg-slate-900 text-white flex-shrink-0">
                  <Check weight="bold" className="h-3.5 w-3.5" />
                </span>
                <span className="text-sm text-slate-700 leading-snug">{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
